import {
  ColocaTokenIcon,
  type ColocaTokenIconProps,
} from "@/shared/components/data-display/ColocaCryptoIcon";

export type UsdtTokenIconProps = Omit<ColocaTokenIconProps, "symbol" | "fallback">;

export function UsdtTokenIcon({ size = 24, ...rest }: UsdtTokenIconProps) {
  return <ColocaTokenIcon symbol="USDT" size={size} {...rest} />;
}
